getEntry